module.exports = __webpack_public_path__ + "static/media/no-image-icon.af879c88.jpg";